module.exports = __webpack_public_path__ + "img/alizee.2efde8fa.jpg";